<template>
  <b-modal v-model="isOpen" size="lg" hide-backdrop hide-footer no-close-on-esc
           no-close-on-backdrop hide-header>
    <div class="editor-container">
      <quill-editor
          v-model="content"
          :options="editorOptions"
      ></quill-editor>
      <slot name="custom-content"></slot>

      <div class="text-right">
        <button class="btn btn-secondary btn-custom-sm mr-2" @click="closeEditor">Cancel</button>
        <button class="btn btn-primary btn-custom-sm" @click="saveContent">Save</button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css"
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";


export default {
  components: {
    quillEditor,
  },
  props: {
    value: String, // Initial content
    isOpen: Boolean, // Control modal visibility
  },
  data() {
    return {
      content: this.value,
      editorOptions: {
        theme: "snow",
        modules: {
          toolbar: [
            [{ font: [] }, { size: [] }],
            ["bold", "italic", "underline", "strike"],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            [{list:"ordered"},{list:"bullet"}],
            ["link", "image"],
            ["blockquote"],
            ["clean"], // Remove formatting
          ],
        },
      },
    };
  },
  watch: {
    value(newValue) {
      this.content = newValue; // Keep content in sync
    },
  },
  methods: {
    saveContent() {
      this.$emit("save", this.content); // Emit HTML content
      // this.$emit("update:isOpen", false); // Close editor
    },
    closeEditor() {
      this.$emit("update:isOpen", false);
      this.$emit("close");
    },
  },
};
</script>

<style scoped>

.btn-custom-sm {
  padding: 0.25rem 0.5rem; /* Adjust padding to make the button smaller */
  font-size: 0.75rem; /* Adjust font size */
  line-height: 1.2; /* Adjust line height for better alignment */
}


::v-deep .ql-editor ol li{
  list-style-type: decimal !important;
}

::v-deep .ql-editor ul{
  margin-bottom: 0;
}

::v-deep .ql-editor ul li{
  padding-left: 1.5em;
  margin:auto;
  list-style-type: disc !important;
}
</style>
